/**
 * Lightweight public-landing footer. Three columns on desktop:
 *   Left   → BBK brand mark + descriptor
 *   Center → research-use disclaimer + support contact
 *   Right  → copyright
 *
 * Refunds / FAQ / other legal pages live behind the auth gate, so this footer
 * intentionally stays quiet — no dozen inline links.
 */
export default function LandingFooter() {
  return (
    <footer
      className="bg-bone border-t border-borderSubtle"
      data-testid="landing-footer"
      aria-label="Site footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-10 sm:py-12">
        <div className="grid gap-8 sm:grid-cols-3 sm:items-center">
          {/* Left — brand */}
          <div className="flex items-center gap-3">
            <div
              className="w-10 h-10 grid place-items-center border-2 border-charcoal rounded-full"
              aria-hidden
            >
              <span className="font-serif text-xs font-semibold tracking-wider text-charcoal">
                BBK
              </span>
            </div>
            <div>
              <p className="font-serif text-lg text-charcoal leading-none">
                Bulk Buy Kits
              </p>
              <p className="mt-1 text-[12px] uppercase tracking-[0.24em] text-charcoal/75">
                Wholesale research kits
              </p>
            </div>
          </div>

          {/* Center — disclaimer + support */}
          <div className="sm:text-center space-y-2">
            <p className="text-xs sm:text-[13px] text-charcoal/85 leading-relaxed">
              For research purposes only. Not for human or animal consumption.
            </p>
            <p className="text-xs sm:text-[13px] text-charcoal/85">
              Compliance &amp; support:{" "}
              <a
                href="mailto:support@bulkbuykits.com"
                className="text-oxblood hover:text-charcoal underline underline-offset-2 decoration-oxblood/40 hover:decoration-charcoal font-mono"
                data-testid="footer-support-email"
              >
                support@bulkbuykits.com
              </a>
            </p>
          </div>

          {/* Right — copyright */}
          <p className="text-xs sm:text-[13px] text-charcoal/75 sm:text-right">
            © {new Date().getFullYear()} Bulk Buy Kits. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
